export const categories = {
  "categories.title": "Browse All Categories",
  "categories.explore": "Explore all categories",
  "categories.subtitle": "Discover suppliers by business sector and find exactly what you're looking for",
  "categories.search_placeholder": "Search a category...",
  "categories.no_results": "No categories found",
  "categories.try_keywords": "Try with different keywords",
  "categories.stats_title": "Suji in numbers",
  "categories.stats_subtitle": "The leading platform for Nigerian suppliers",
  "categories.verified_suppliers": "Verified suppliers",
  "categories.product_categories": "Product categories",
  "categories.states_covered": "States covered",
  "categories.monthly_searches": "Monthly searches",
  "categories.explore_category": "Explore this category"
};

export default categories;
